export enum XpertFormStep {
  ReferralCode = 'referral_code',
  ReferralCodeTrue = 'referral_code_true',
  ReferralCodeFalse = 'referral_code_false',
  ReferralNotFound = 'referral_not_found',
  FillMoreInformation = 'fill_more_information',
  SelectDateTime = 'select_date_time',
  SelectClinic = 'select_clinic',
  ConfirmPersonalDetails = 'confirm_personal_details',
  ProposedAppointment = 'proposed_appointment',
  DifferentTimeSlot = 'diﬀerent_time_slot',
  ConfirmAllDetails = 'confirm_all_details',
  AppointmentConfirmed = 'appointment_confirmed',
}
